export default __webpack_public_path__ + "static/media/guild-positive.baf0fa09.svg";